import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useConfig } from "./config";
import { toast } from "react-hot-toast";
import "./Login.css";

function RequestAccount() {
  const [email, setEmail] = useState("");
  const [adminEmail, setAdminEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const { config } = useConfig();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim() || !adminEmail.trim()) {
      toast.error("Please fill in all fields");
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch(
        `${config.API_BASE_URL}/api/auth/request-account`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            requester_email: email,
            admin_email: adminEmail,
          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || "Failed to request account");
      }

      toast.success("Account request sent successfully!");
      navigate("/login");
    } catch (error) {
      console.error("Account request error:", error);
      toast.error(
        error.message || "Failed to request account. Please try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h2>Request an Account</h2>
        <p className="login-description">
          Enter your email and a super admin's email to request an account
        </p>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Your Email Address</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="adminEmail">Super Admin's Email</label>
            <input
              type="email"
              id="adminEmail"
              value={adminEmail}
              onChange={(e) => setAdminEmail(e.target.value)}
              placeholder="admin@example.com"
              required
            />
          </div>

          <button
            type="submit"
            className="login-button"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Sending..." : "Request Account"}
          </button>
        </form>

        <div className="login-footer">
          <p>A super admin will review your request and approve or deny it.</p>
        </div>

        <div className="login-footer-links">
          <button
            onClick={() => navigate("/login")}
            className="back-to-login-button"
          >
            Back to Login
          </button>
        </div>
      </div>
    </div>
  );
}

export default RequestAccount;
